var _rect, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhostWithArrowsMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: 223,
    width: 257,
    height: 130,
    viewBox: "0 25 257 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 52,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#131313"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.145 107.186L121.466 108.806H118.823L120.145 107.186Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.448 107.186L130.77 108.806H128.127L129.448 107.186Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 108.048C112.198 98.9268 113.396 89.8038 114.595 80.6794C114.815 79.814 115.677 76.8781 118.506 74.8378C121.05 73.0042 123.659 72.9912 124.638 72.9988C125.531 73.0075 128.19 73.067 130.558 74.8378C132.711 76.4464 133.983 78.6619 134.259 80.6794C135.506 89.8017 136.753 98.9247 138 108.048C137.805 108.282 136.256 110.076 133.73 109.996C131.004 109.909 129.532 107.718 129.395 107.507C129.257 107.714 127.693 109.967 124.849 109.996C121.939 110.024 120.324 107.696 120.198 107.507C120.008 107.764 118.279 110.015 115.335 109.996C112.845 109.979 111.279 108.35 111 108.048Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 87.4119C127.761 87.4119 130 86.6438 130 85.6962C130 84.7486 127.761 83.9805 125 83.9805C122.239 83.9805 120 84.7486 120 85.6962C120 86.6438 122.239 87.4119 125 87.4119Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2844 69.4763C83.1487 68.2813 82.8851 67.1035 82.4982 65.9636L81.1283 66.4842C81.461 67.5129 81.6805 68.5746 81.7827 69.65L83.2844 69.4763ZM79.7363 63.44L81.0165 62.6835C80.4161 61.6498 79.7203 60.6753 78.9384 59.7729L77.7531 60.7792C78.4794 61.6091 79.1251 62.5071 79.6815 63.4608L79.7363 63.44ZM75.397 58.4983L76.3146 57.3238C75.3824 56.5768 74.3788 55.926 73.3189 55.3813L72.6448 56.7015C73.6183 57.2071 74.5403 57.809 75.397 58.4983ZM69.5577 55.5084L69.9524 54.072C68.8011 53.7422 67.6171 53.5473 66.4239 53.4913L66.3664 54.9901C67.4608 55.02 68.5489 55.1823 69.6072 55.4737L69.5577 55.5084ZM44.3027 62.5649L43.7753 61.1772C42.7622 61.5564 41.7307 61.8848 40.6846 62.1612L41.0476 63.6113C42.1684 63.3124 43.2716 62.9515 44.3522 62.5302L44.3027 62.5649ZM47.504 61.2531C48.5725 60.847 49.583 60.2883 50.6061 59.8042L49.9555 58.4633C48.9513 58.9561 47.9281 59.4402 46.8944 59.8966L47.504 61.2531ZM63.1036 55.1501L62.8777 53.6479C61.7172 53.8124 60.5719 54.0671 59.4517 54.4099L59.8695 55.8392C60.9453 55.5206 62.0425 55.2788 63.1532 55.1154L63.1036 55.1501ZM53.6651 58.3241C54.6745 57.8452 55.7082 57.3888 56.7441 56.9793L56.2167 55.5916C55.1482 55.9977 54.1061 56.4731 53.0555 56.9676L53.6651 58.3241ZM37.5046 64.1478L37.3609 62.6143C36.616 62.6963 35.8656 62.7214 35.1161 62.6892C34.8118 62.678 34.5082 62.6503 34.2066 62.6061L33.9994 64.0823C34.3396 64.1362 34.6823 64.1704 35.0259 64.1846C35.8698 64.2307 36.7154 64.2068 37.5542 64.1131L37.5046 64.1478ZM30.4708 63.0888L31.0257 61.7027C30.0435 61.2739 29.1204 60.717 28.2799 60.0464L27.4003 61.2382C28.3603 61.975 29.4088 62.5853 30.5203 63.0541L30.4708 63.0888ZM24.8628 58.6451L26.0956 57.7638C25.6925 57.1906 25.3616 56.5695 25.1107 55.9147C24.9818 55.5915 24.8812 55.2577 24.81 54.9173L23.3663 55.2436C23.4584 55.6504 23.579 56.0504 23.7271 56.4405C24.0158 57.2185 24.3972 57.9589 24.8628 58.6451ZM24.7111 51.8104C24.9259 50.7455 25.2641 49.7108 25.7187 48.7277L24.3664 48.0982C23.8588 49.193 23.4869 50.3477 23.2588 51.5365L24.7111 51.8104ZM27.2164 45.697C27.7778 44.6578 28.3192 43.6898 28.7509 42.5569L27.3817 41.9656C26.9542 42.9856 26.4159 43.9207 25.9115 44.9859L27.2164 45.697ZM29.7068 39.0492C29.8476 37.8297 29.801 36.5939 29.5686 35.3855L28.1091 35.6702C28.3155 36.7014 28.3571 37.758 28.2323 38.7996L29.7068 39.0492ZM26.9647 32.6589L28.2608 31.944C27.6975 30.8607 26.9944 29.8569 26.17 28.9588L25.1513 29.9495C25.8815 30.7605 26.4923 31.6731 26.9647 32.6589ZM22.6087 27.9618L23.3534 26.6624C22.4101 26.1031 21.391 25.6876 20.3295 25.4294L20.0601 26.8658C20.9802 27.0995 21.8613 27.4713 22.674 27.9688L22.6087 27.9618Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4605 67.3939L76.0286 66.0171L82.8005 68.9425L85.1338 61.9915L86.5381 62.4885L83.6962 70.9554L75.4605 67.3939Z",
    fill: "url(#paint2_linear_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.619 152.979L241.225 152.619L241.653 149.905L243.06 150.244C242.872 151.124 242.74 152.048 242.619 152.979ZM243.263 147.391L241.907 147.133C241.979 146.203 242.034 145.276 242.058 144.345L243.413 144.548C243.395 145.495 243.329 146.443 243.263 147.391ZM243.375 141.668L242.023 141.547C241.968 140.586 241.873 139.643 241.771 138.71L243.121 138.721C243.235 139.688 243.326 140.669 243.375 141.668ZM242.531 135.802L241.202 135.924C240.987 135.075 240.717 134.231 240.394 133.397L240.311 133.175L241.581 132.899L241.671 133.138C242.002 134.029 242.283 134.928 242.513 135.833L242.531 135.802ZM240.19 130.073L239.02 130.54C238.51 129.686 237.938 128.857 237.308 128.061L238.365 127.424C239.036 128.283 239.64 129.179 240.173 130.104L240.19 130.073ZM236.138 125.009L235.212 125.841C234.473 125.132 233.673 124.478 232.823 123.888L233.543 122.941C234.452 123.584 235.314 124.286 236.121 125.04L236.138 125.009ZM230.167 122.3C229.239 121.871 228.274 121.537 227.293 121.304L227.49 120.064C228.575 120.339 229.641 120.721 230.667 121.203L230.167 122.3ZM224.32 120.913C224.058 120.909 223.798 120.917 223.541 120.937C222.84 120.977 222.154 121.077 221.491 121.237L220.992 120.015C221.74 119.851 222.509 119.743 223.293 119.694L224.169 119.669L224.32 120.913ZM218.851 122.139C218.085 122.453 217.279 122.84 216.256 123.389L215.472 122.277C216.496 121.756 217.338 121.362 218.128 121.061L218.851 122.139ZM213.758 124.693C212.988 125.1 212.088 125.569 211.174 125.95L210.45 124.817C211.351 124.403 212.239 123.954 212.984 123.533L213.758 124.693ZM208.323 127.057C207.319 127.321 206.268 127.478 205.192 127.523L204.915 126.275C205.882 126.214 206.824 126.052 207.721 125.791L208.323 127.057ZM201.931 127.363C200.836 127.147 199.755 126.807 198.715 126.351L199.142 125.241C200.073 125.66 201.043 125.97 202.027 126.162L201.931 127.363ZM196.453 123.741L195.77 124.709C194.821 124.065 193.917 123.363 193.065 122.608L193.931 121.742C194.712 122.435 195.542 123.079 196.415 123.666L196.453 123.741ZM191.685 119.734L190.697 120.532C189.989 119.8 189.273 119.023 188.531 118.151L189.564 117.472C190.301 118.153 190.98 118.909 191.67 119.618L191.685 119.734ZM187.618 115.011L186.554 115.632L186.008 114.923C185.55 114.344 185.073 113.74 184.614 113.161L185.671 112.523L187.063 114.176L187.618 115.011ZM183.618 110.084L182.61 110.776C181.869 109.931 181.166 109.188 180.465 108.501L181.416 107.682C182.11 108.326 182.832 109.119 183.603 109.967L183.618 110.084ZM178.944 105.535L178.127 106.428C177.326 105.773 176.474 105.176 175.58 104.644L176.154 103.615C177.123 104.148 178.052 104.752 178.929 105.419L178.944 105.535ZM172.814 103.196C171.861 102.85 170.878 102.619 169.894 102.511L169.868 101.27C170.971 101.398 172.07 101.658 173.139 102.042L172.814 103.196Z",
    fill: "url(#paint3_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.964 150.119L247.085 149.062L241.986 152.342L238.01 146.942L236.916 147.531L241.762 154.118L247.964 150.119Z",
    fill: "url(#paint4_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 132.811,
    y1: 87.0923,
    x2: 126.771,
    y2: 80.3132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 19.9229,
    y1: 87.2245,
    x2: 72.7307,
    y2: 45.7245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 76.5322,
    y1: 74.9007,
    x2: 83.0174,
    y2: 62.1874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 249.136,
    y1: 124.326,
    x2: 231.903,
    y2: 149.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 248.277,
    y1: 147.471,
    x2: 241.939,
    y2: 154.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 37,
    fill: "white",
    transform: "translate(111 73)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.9169,
    height: 76.2853,
    fill: "white",
    transform: "matrix(-0.877603 0.479388 0.479388 0.877603 58.7266 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.298,
    height: 91.9977,
    fill: "white",
    transform: "translate(164.442 111) rotate(-60.8537)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostWithArrowsMobile);
export default __webpack_public_path__ + "static/media/GhostWithArrowsMobile.c741de67659b71ee41738ceea1698469.svg";
export { ForwardRef as ReactComponent };